
import React, { Component } from 'react'
import CreateProject from './CreateProject'
import ViewProject from './ViewProject'
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from '../../../constants';
import { Messager } from 'rc-easyui';



const axios = require("axios");
export default class Project extends Component {
    constructor() {
        super()
        this.childRef = React.createRef()
        this.state = {
            project: {
                projectManagerId: "",
                projectName: "",
            },
            projectList: [],
            rules: {
                projectManagerId: ['required'],
                projectName: ['required'],
            },
            operation: "Add",
            selected: {},
            permissions: [],
        }

    }
    componentDidMount = () => {
        var data = getCookie('permission');
        this.setState({
            permissions: JSON.parse(data),
        },


            function () {
                setTitle('Project Info. Entry')

                this.getProjectID()
            }
        );
    }


    OnEditClick = (row) => {
        // let form = { ...this.state.project }
        this.setState({
            project: row
        }, () => {
            this.setState({
                operation: 'operation'
            })
        })
    }
    handleInput = (name, value) => {

        const newArr = { ...this.state.Ticket }
        newArr[name] = value
        this.setState({
            student: newArr

        })

    }
    // formClear=()=> {
    //     let clearTicket = {
    //          priority:""
    //     };
    //     this.setState({
    //         prioirty: clearTicket,
    //         operation: "Add",
    //       },
    //       function () {
    //            this.childRef.current.validate((errors) => {});
    //                   }
    //               );
    //   }
    //   OnEditClick=()=> {
    //  var rules = this.state.rules;
    //     console.log( this.state.selected);
    //     if (this.state.selected != null) {

    //       this.setState({
    //         rules: rules,
    //         priority: this.state.selected,
    //         operation: "Update",
    //       });

    //       const timer = setTimeout(() => {
    //         this.childRef.current.validate((errors) => {});
    //       }, 100);
    //       return () => clearTimeout(timer);
    //     }
    //   }
    //   onSelectionChange=(selectedRow)=> {
    //       console.log(selectedRow)
    //     this.setState({
    //       selected: selectedRow,
    //     });
    //   }

    getProjectID = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            let url = API_URL + 'api/fetchallprojectInfo';
            axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data.object

                        this.setState({
                            projectList: dataObject
                        })

                    } else {
                        this.setState({
                            projectList: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        projectList: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })
        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getProjectID()
            }
        }

    }



    render() {

        return (
            <div>
                <Messager ref={ref => this.messager = ref}></Messager>

                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-4'>


                            <CreateProject
                                project={this.state.project}
                                handleInput={this.handleInput}
                                operation={this.state.operation}
                                rules={this.state.rules}
                                ref={this.childRef}
                                formClear={this.formClear}
                            />
                        </div>
                        <div className='col-8'>
                            <ViewProject

                                OnEditClick={this.OnEditClick}
                                onSelectionChange={this.onSelectionChange}
                                selectedRow={this.state.selected}

                                permissions={this.state.permissions}

                            />
                        </div>

                    </div>
                </div>

            </div>
        )
    }
}
